import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input, OnChanges,
  OnInit, SimpleChanges
} from '@angular/core';
import { CashFlowByPeriod } from '@financial/domain';
import { CashFlowByPeriodService } from './cash-flow-by-period.service';
import * as moment from 'moment';
import { YearMonth } from '@financial/arch';

@Component({
  selector: 'app-cash-flow-by-period',
  templateUrl: './cash-flow-by-period.component.html',
  styleUrls: ['./cash-flow-by-period.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CashFlowByPeriodComponent implements OnInit, OnChanges {

  @Input() selectedDate: Date = new Date();

  cashFlow: CashFlowByPeriod[] = [];

  chartData: any[] = [];

  colorScheme = {
    domain: [
      '#4db6ac',
      '#f44336',
      '#9E9E9E'
    ]
  };

  view: [number, number] = [null, 330];

  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  showXAxisLabel = false;
  showYAxisLabel = false;
  legendPosition = 'below';

  constructor(
    private cashFlowByPeriodService: CashFlowByPeriodService,
    private changeDetection: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.fetchData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedDate && !changes.selectedDate.firstChange) {
      this.fetchData();
    }
  }

  private fetchData() {
    const yearMonth = YearMonth.fromMoment(moment(this.selectedDate));

    this.cashFlowByPeriodService.findBy(yearMonth).subscribe(
      result => {
        const isAllZero = result.income === 0 && result.expense === 0;

        if (result && !isAllZero) {
          this.cashFlow = [result];

          this.chartData = [
            {
              name: moment(this.selectedDate).format('MM/YYYY'),
              series: [
                {
                  name: 'Receitas',
                  value: result.income
                },
                {
                  name: 'Despesas',
                  value: result.expense
                },
                {
                  name: 'Balanço',
                  value: result.balance
                }
              ]
            }
          ];
        } else {
          this.cashFlow = [];
          this.chartData = [];
        }

        this.changeDetection.markForCheck();
      },
      error => console.log(error)
    );
  }

  yAxisTickFormatting(val: number): string {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      maximumFractionDigits: 0
    }).format(val);
  }
}
